import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";
import { GetLabRegistrationById, UpdateLabRegistration } from "../../../../api/diagnosis/transaction/labRegistrationAPI";
import { GetConsultants } from "../../../../api/masters/consultantAPI";
import { GetAreas } from "../../../../api/masters/areaAPI";
import { GetOpdEntries } from "../../../../api/opd/opdEntryAPI";
import { GetIpdEntries } from "../../../../api/ipd/ipdEntryAPI";
import { GetPathologyTests } from "../../../../api/diagnosis/master/pathologyTestAPI";
import { GetRadiologyTests } from "../../../../api/diagnosis/master/radiologyTestAPI";
import { GetDepartmentalSubSpecialities } from "../../../../api/diagnosis/master/departmentalSubSpecilityAPI";
import Select from "react-select";

// Validation schema using Yup
const schema = yup.object().shape({
    lab: yup.string().required("Lab is required"),
    date: yup.date().required("Date is required"),
    time: yup.string().required("Time is required"),
    labNo: yup.string().required("Lab No is required"),
    type: yup.string().required("Type is required"),

    patientName: yup.string().required("Patient name is required"),
    sex: yup.string().required("Sex is required"),
    age: yup.string().required("Age is required"),
    ageSuffix: yup.string().required("Age suffix is required"),

    areaId: yup.string().optional(),
    collactionCenter: yup.string().optional(),
    rateMode: yup.string().required("Rate mode is required"),
    referenceDoctorId: yup.string().optional(),
    consultantDoctorId: yup.string().required("Consultant doctor is required"),

    paymentMode: yup.string().required("Payment mode is required"),
    debitAccount: yup.string().optional(),

    total: yup.number().required("Total is required"),
    advance: yup.number(),
    balance: yup.number(),

    testDetails: yup.array().of(
        yup.object().shape({
            type: yup.string().required("Test type is required"),
            shortName: yup.string().required("Short name is required"),
            testId: yup.string().required("Test ID is required"),
            rate: yup.number().required("Rate is required"),
            doctorId: yup.string().optional(),
        })
    ).min(1),

    grossAmount: yup.number().typeError("Gross amount must be a number").required("Gross amount is required"),
    otherCharges: yup.number().typeError("Other charges must be a number").required("Other charges are required"),
    debitAccount: yup.string().required("Debit account is required"),
    discountPercentage: yup.number().typeError("Discount percentage must be a number").required("Discount percentage is required"),
    discountAmount: yup.number().typeError("Discount amount must be a number").required("Discount amount is required"),
    total: yup.number().typeError("Total must be a number").required("Total is required"),
    balance: yup.number().typeError("Balance must be a number").required("Balance is required"),
    paymentMode: yup.string().required("Payment mode is required"),
    remark: yup.string().optional(),
});

const EditLabRegitrationEntry = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { id } = useParams();

	const [consultants, setConsultants] = useState([]);
        const [areas, setAreas] = useState([]);
    
        const [ipdEntries, setIpdEntries] = useState([]);
        const [opdEntries, setOpdEntries] = useState([]);
        const [pathologyTests, setPathologyTests] = useState([]);
        const [radiologyTests, setRadiologyTests] = useState([]);
        const [filteredTests, setFilteredTests] = useState([]);
    
        const [selectedOpd, setSelectedOpd] = useState({});
        const [selectedIpd, setSelectedIpd] = useState({});
        const [departmentalSubSpecialities, setDepartmentalSubSpecialities] = useState([]);
        const [selectedDepartment, setSelectedDepartment] = useState(null);
    
        const [combinedDetails, setCombinedDetails] = useState([]);
    
        const {
            register,
            handleSubmit,
            control,
            setValue,
            getValues,
            watch,
            formState: { errors }
        } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                date: new Date().toISOString().split("T")[0],
                time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }),
            }
        });
    
        const { fields, append, remove, replace } = useFieldArray({
            control,
            name: "testDetails"
        });
    
        const testDetails = useWatch({
            control,
            name: "testDetails"
        });
    
        const type = watch("type");

	 const fetchConsultants = async () => {
            try {
                const response = await GetConsultants();
                if (response.success) {
                    setConsultants(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const fetchAreas = async () => {
            try {
                const response = await GetAreas();
                if (response.success) {
                    setAreas(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const fetchOpdEntries = async () => {
            try {
                const response = await GetOpdEntries();
                if (response.success) {
                    setOpdEntries(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const fetchIpdEntries = async () => {
            try {
                const response = await GetIpdEntries();
                if (response.success) {
                    setIpdEntries(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
    
        const fetchPathologyTests = async () => {
            try {
                const response = await GetPathologyTests();
                if (response.success) {
                    setPathologyTests(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const fetchRadiologyTests = async () => {
            try {
                const response = await GetRadiologyTests();
                if (response.success) {
                    setRadiologyTests(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const fetchDepartments = async () => {
            try {
                const response = await GetDepartmentalSubSpecialities();
                if (response.success) {
                    setDepartmentalSubSpecialities(response.data);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        const loadAllData = async () => {
            await Promise.all([
                fetchConsultants(),
                fetchAreas(),
                fetchOpdEntries(),
                fetchIpdEntries(),
                fetchPathologyTests(),
                fetchRadiologyTests(),
                fetchDepartments()
            ]);
        };

	const fetchData = async () => {
            try {
                const response = await GetLabRegistrationById(id);
    
                if (!response.success) {
                    showToast("error", response.message);
                    return;
                }
    
                const data = response.data;
    
                // =============================
                // BASIC FIELDS
                // =============================
                setValue("date", data.date?.split("T")[0]);
                setValue("time", data.time);
                setValue("labNo", data.labNo);
                setValue("serialNo", data.serialNo);
                setValue("sampleDate", data.sampleDate.split("T")[0]);
                setValue("sampleTime", data.sampleTime);
                setValue("type", data.type);
    
                setValue("patientName", data.patientName);
                setValue("sex", data.sex);
                setValue("age", data.age);
                setValue("ageSuffix", data.ageSuffix);
                setValue("guardianName", data.guardianName);
                setValue("mobileNo", data.mobileNo);
                setValue("address", data.address);
    
                setValue("areaId", data.areaId?._id || "");
                setValue("referenceDoctorId", data.referenceDoctorId?._id || "");
                setValue("consultantDoctorId", data.consultantDoctorId?._id || "");
    
                setValue("collactionCenter", data.collactionCenter);
                setValue("rateMode", data.rateMode);
                setValue("paymentMode", data.paymentMode);
                setValue("debitAccount", data.debitAccount);
                

                setValue("grossAmount", data.grossAmount);
                setValue("otherCharges", data.otherCharges || 0);
                setValue("discountAmount", data.discountAmount || 0);
                setValue("discountPercentage", data.discountPercentage || 0);
                setValue("total", data.total);
                setValue("advance", data.advance);
                setValue("balance", data.balance);
    
                // =============================
                // OPD / IPD
                // =============================
                if (data.opdEntryId) {
                    setSelectedOpd(data.opdEntryId);
                    setValue("opdEntryId", data.opdEntryId._id);
                    setValue("uhidNo", data.opdEntryId.patientId?.uhidNo);
                }
    
                if (data.ipdEntryId) {
                    setSelectedIpd(data.ipdEntryId);
                    setValue("ipdEntryId", data.ipdEntryId._id);
                    setValue("roomNo", data.ipdEntryId.roomId?.roomNo);
                    setValue("uhidNo", data.ipdEntryId.patientId?.uhidNo);
                }
    
                // =============================
                // LAB (Department)
                // =============================
                if (data.lab) {
                    setSelectedDepartment(data.lab);
                    setValue("lab", data.lab._id);
    
                    setFilteredTests(
                        pathologyTests.filter(
                            t =>
                                t?.investigationCategoryId?.departmentalSubSpecialityId?._id ===
                                data.lab._id
                        )
                    );
                }
    
                // =============================
                // TEST DETAILS (IMPORTANT)
                // =============================
                const formattedTests = data.testDetails.map(test => ({
                    type: test.type,
                    testId: test.testId?._id,
                    shortName: test.shortName,
                    rate: test.rate,
                    doctorId: test.doctorId?._id || "",
                    departmentalSubSpecialityId:
                        test.testId?.investigationCategoryId?.departmentalSubSpecialityId?._id,
                    departmentalSubSpecialityName:
                        test.testId?.investigationCategoryId?.departmentalSubSpecialityId?.name,
                    rateEditable: test.rateEditable || false
                }));
    
                replace(formattedTests);
    
            } catch (error) {
                showToast("error", error.message);
            }
        };
    
        // Fetch existing data
        useEffect(
            () => {
                if (id) {
                    loadAllData().then(() => {
                        fetchData();
                    });
                }
            },
            [id, setValue]
        );

	const onSubmit = async data => {
            try {
                dispatch({ type: "LOADER_START" });
    
                const response = await UpdateLabRegistration(id, data);
                if (response.success) {
                    showToast("success", response.message);
                } else {
                    showToast("error", response.message);
                }
            } catch (error) {
                showToast("error", error);
            } finally {
                dispatch({ type: "LOADER_STOP" });
            }
        };

    const formRef = useRef(null);
      useKeyboardSubmit(handleSubmit, onSubmit);
      useEnterNavigation(formRef);

	return (
		<Fragment>
			<Breadcrumb parent="Lab" title="Edit Lab Registration" />

			<div className="container-fluid">
				<div className="card">
					<div className="card-header d-flex justify-content-between">
						<h5>Edit Lab Registration</h5>
						<Link to={`/diagnosis/transaction/lab-registration-entry/list`}>
							<button className="btn btn-primary" id="list">
								Lab Registration List
							</button>
							<UncontrolledTooltip target="list">
								Lab Registration List
							</UncontrolledTooltip>
						</Link>
					</div>

					<form
						ref={formRef}
						className="form theme-form"
						onSubmit={handleSubmit(onSubmit)}
					>
						<div className="card-body">

							{/* LAB INFO */}
							<div className="col-12">
								<h5 className="mt-3 mb-3 text-primary">
									Lab Information
								</h5>
							</div>
							<div className="row">
								<div className="col-md-4">
									<label>Lab</label>
									<Select
										options={departmentalSubSpecialities.map((dept) => ({
											value: dept._id,
											label: dept.name,
											dept: dept
										}))}
                                        value={
                                            selectedDepartment?._id
                                                ? {
                                                    value: selectedDepartment._id,
                                                    label: selectedDepartment.name
                                                }
                                                : null
                                        }
										placeholder="Select Department..."
										isClearable
										onChange={async (selectedOption) => {
											if (!selectedOption) {
												setSelectedDepartment(null);
												setFilteredTests([]);
												return;
											}

											setSelectedDepartment(selectedOption.dept);
											setValue("lab", selectedOption.value);
											setFilteredTests(pathologyTests.filter(pathologyTest => pathologyTest?.investigationCategoryId?.departmentalSubSpecialityId?._id === selectedOption.value));
										}}
									/>
								</div>
								<div className="col-md-4">
									<label>Date</label>
									<input type="date" className="form-control" {...register("date")} />
									{errors.date && <span className="text-danger">{errors.date.message}</span>}
								</div>

								<div className="col-md-4">
									<label>Time</label>
									<input type="time" className="form-control" {...register("time")} />
									{errors.time && <span className="text-danger">{errors.time.message}</span>}
								</div>
							</div>

							<div className="row mt-3">
								<div className="col-md-3">
									<label>Lab No</label>
									<input type="number" className="form-control" {...register("labNo")} readOnly />
									{errors.labNo && <span className="text-danger">{errors.labNo.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Serial No</label>
									<input type="number" className="form-control" {...register("serialNo")} />
									{errors.serialNo && <span className="text-danger">{errors.serialNo.message}</span>}
								</div>

								<div className="col-md-3">
									<label>Sample Date</label>
									<input type="date" className="form-control" {...register("sampleDate")} />
									{errors.sampleDate && <span className="text-danger">{errors.sampleDate.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Sample Time</label>
									<input type="time" className="form-control" {...register("sampleTime")} />
									{errors.sampleTime && <span className="text-danger">{errors.sampleTime.message}</span>}
								</div>
							</div>

							<div className="row mt-3">
								<div className="col-md-4">
									<label>Type</label>
									<select type="number" className="form-control"
										{...register("type")}
									>
										<option value="">Select</option>
										<option>OPD</option>
										<option>IPD</option>
										<option>General</option>
									</select>
									{errors.type && <span className="text-danger">{errors.type.message}</span>}
								</div>

								{
									type === "OPD" &&
									<div className="col-md-4">
										<label>OPD No</label>
										<Select
											options={opdEntries.map((opd) => ({
												value: opd._id,
												label: `${opd.opdNo} - ${opd.patientId?.patientName}`,
												opd: opd, // store full object
											}))}
                                            value={
                                                selectedOpd?._id
                                                    ? {
                                                        value: selectedOpd._id,
                                                        label: `${selectedOpd.opdNo} - ${selectedOpd.patientId?.patientName}`
                                                    }
                                                    : null
                                            }
											placeholder="Search OPD..."
											isClearable
											onChange={(selectedOption) => {
												if (!selectedOption) {
													setValue("opdEntryId", "");
													return;
												}

												// set id in form
												setValue("opdEntryId", selectedOption.opd?._id);
												setValue("opdNo", selectedOption.opd?.opdNo);
												setSelectedOpd(selectedOption.opd);
												console.log(selectedOption);
											}}
										/>
										{errors.opdNo && <span className="text-danger">{errors.opdNo.message}</span>}
									</div>
								}
								{
									type === "IPD" &&
									<>
										<div className="col-md-4">
											<label>IPD No</label>
											<Select
												options={ipdEntries.map((ipd) => ({
													value: ipd._id,
													label: `${ipd.ipdNo} - ${ipd.patientId?.patientName}`,
													ipd: ipd, // store full object
												}))}
                                                value={
                                                    selectedIpd?._id
                                                        ? {
                                                            value: selectedIpd._id,
                                                            label: `${selectedIpd.ipdNo} - ${selectedIpd.patientId?.patientName}`
                                                        }
                                                        : null
                                                }
												placeholder="Search IPD..."
												isClearable
												onChange={(selectedOption) => {
													if (!selectedOption) {
														setValue("ipdEntryId", "");
														return;
													}

													// set id in form
													setValue("ipdEntryId", selectedOption.ipd?._id);
													setValue("roomNo", selectedOption.ipd?.roomId?.roomNo);

													setSelectedIpd(selectedOption.ipd);
												}}
											/>
											{errors.ipdNo && <span className="text-danger">{errors.ipdNo.message}</span>}
										</div>
										<div className="col-md-4">
											<label>Room No</label>
											<input className="form-control" {...register("roomNo")} readOnly />
											{errors.roomNo && <span className="text-danger">{errors.roomNo.message}</span>}
										</div>
									</>
								}

								{
									(type === "OPD" || type === "IPD") &&
									<div className="col-md-4">
										<label>UHID No</label>
										<input type="text" className="form-control" {...register("uhidNo")} />
										{errors.uhidNo && <span className="text-danger">{errors.uhidNo.message}</span>}
									</div>
								}
							</div>

							<hr />

							{/* PATIENT INFO */}
							<div className="col-12">
								<h5 className="mt-3 mb-3 text-primary">
									Patient Information
								</h5>
							</div>
							<div className="row">
								<div className="col-md-4">
									<label>Patient Name</label>
									<input className="form-control" {...register("patientName")}
										readOnly={(type === "OPD" || type === "IPD") ? true : false}
									/>
									{errors.patientName && <span className="text-danger">{errors.patientName.message}</span>}
								</div>

								<div className="col-md-4">
									<label>Sex</label>
									<select className="form-control" {...register("sex")}>
										<option value="">Select</option>
										<option>Male</option>
										<option>Female</option>
									</select>
									{errors.sex && <span className="text-danger">{errors.sex.message}</span>}
								</div>

								<div className="col-md-4">
									<label>Age</label>
									<div className="input-group">
										<input
											type="number"
											className="form-control"
											placeholder="Age"
											{...register("age")}
										/>
										<select
											className="form-select"
											{...register("ageSuffix")}
										>
											<option value="Years">Years</option>
											<option value="Months">Months</option>
											<option value="Days">Days</option>
										</select>
									</div>
									{errors.age && <span className="text-danger">{errors.age.message}</span>}
									{errors.ageSuffix && <span className="text-danger">{errors.ageSuffix.message}</span>}
								</div>
							</div>

							<div className="row mt-3">
								<div className="col-md-4">
									<label>Guardian Name</label>
									<input className="form-control" {...register("guardianName")} />
									{errors.guardianName && <span className="text-danger">{errors.guardianName.message}</span>}
								</div>

								<div className="col-md-4">
									<label>Mobile</label>
									<input className="form-control" {...register("mobileNo")} />
									{errors.mobileNo && <span className="text-danger">{errors.mobileNo.message}</span>}
								</div>
								<div className="col-md-4">
									<label>Address</label>
									<textarea className="form-control" {...register("address")} />
									{errors.address && <span className="text-danger">{errors.address.message}</span>}
								</div>
							</div>

							<hr />
							<div className="row mt-3">
								<div className="col-md-4">
									<label>Area</label>
									<select className="form-control" {...register("areaId")}>
										<option value="">Select</option>
										{
											areas.map((item, index) => (
												<option key={index} value={item._id}>{item.name}</option>
											))
										}
									</select>
									{errors.areaId && <span className="text-danger">{errors.areaId.message}</span>}
								</div>

								<div className="col-md-4">
									<label>Reference Doctor</label>
									<select className="form-control" {...register("referenceDoctorId")}>
										<option value="">Select</option>
										{
											consultants.map((item, index) => (
												<option key={index} value={item._id}>{item.name}</option>
											))
										}
									</select>
									{errors.referenceDoctorId && <span className="text-danger">{errors.referenceDoctorId.message}</span>}
								</div>
								<div className="col-md-4">
									<label>Consultant Doctor</label>
									<select className="form-control" {...register("consultantDoctorId")}>
										<option value="">Select</option>
										{
											consultants.map((item, index) => (
												<option key={index} value={item._id}>{item.name}</option>
											))
										}
									</select>
									{errors.consultantDoctorId && <span className="text-danger">{errors.consultantDoctorId.message}</span>}
								</div>
							</div>

							<div className="row mt-3">
								<div className="col-md-4">
									<label>Collaction Center</label>
									<input className="form-control" {...register("collactionCenter")} />
									{errors.collactionCenter && <span className="text-danger">{errors.collactionCenter.message}</span>}
								</div>
								<div className="col-md-4">
									<label>Rate Mode</label>
									<select className="form-control" {...register("rateMode")}>
										<option>Normal</option>
										<option>International</option>
									</select>
									{errors.rateMode && <span className="text-danger">{errors.rateMode.message}</span>}
								</div>
							</div>

							{/* TEST DETAILS */}
							<div className="col-12">
								<h5 className="mt-3 mb-3 text-primary">
									Test Details
								</h5>
							</div>
							{fields.map((item, index) => (
								<div className="row border p-2 mb-2" key={item.id}>
									<div className="col-md-2">
										<label>Type</label>
										<select className="form-control"
											{...register(`testDetails.${index}.type`)} >
											<option value="Test">Test</option>
											<option value="Panel">Panel</option>
										</select>
									</div>

									<div className="col-md-3">
										<label>Test</label>
										<Select
											options={filteredTests.map((patho) => ({
												value: patho._id,
												label: patho.name,
												patho: patho, // store full object
											}))}
                                            value={
                                                testDetails?.[index]?.testId
                                                    ? {
                                                        value: testDetails[index].testId,
                                                        label:
                                                            filteredTests.find(
                                                                t => t._id === testDetails[index].testId
                                                            )?.name || "Selected Test"
                                                    }
                                                    : null
                                            }
											placeholder="Search Test..."
											isClearable
											onChange={(selectedOption) => {
												if (!selectedOption) {
													setValue(`testDetails.${index}.testId`, "");
													return;
												}
												console.log(selectedOption);
												setValue(`testDetails.${index}.shortName`, selectedOption.patho.shortName);
												setValue(`testDetails.${index}.rate`, selectedOption.patho.price);
												setValue(`testDetails.${index}.departmentalSubSpecialityId`, selectedOption.patho?.investigationCategoryId?.departmentalSubSpecialityId?._id);
												setValue(`testDetails.${index}.departmentalSubSpecialityName`, selectedOption.patho?.investigationCategoryId?.departmentalSubSpecialityId?.name);
												// set id in form
												setValue(`testDetails.${index}.testId`, selectedOption.value);
												if (selectedOption.patho.rateEditable == 'Yes') {
													setValue(`testDetails.${index}.rateEditable`, true);
												} else {
													setValue(`testDetails.${index}.rateEditable`, false);
												}
											}}
										/>
									</div>

									<div className="col-md-2">
										<label>Short Name</label>
										<input className="form-control"
											{...register(`testDetails.${index}.shortName`)} />
									</div>

									<div className="col-md-2">
										<label>Rate</label>
										<input type="number" className="form-control"
											readOnly={!testDetails[index]?.rateEditable ? true : false}
											{...register(`testDetails.${index}.rate`)} />
									</div>

									<div className="col-md-2">
										<label>Doctor</label>
										<select className="form-control"
											{...register(`testDetails.${index}.doctorId`)} >
											<option value="">Select</option>
											{consultants.map((item) => (
												<option key={item._id} value={item._id}>
													{item.name}
												</option>
											))}
										</select>
									</div>

									<div className="col-md-2">
										<label>Print Sr No</label>
										<input type="number" className="form-control" {...register(`testDetails.${index}.printSrNo`)} />
										{errors.testDetails && errors.testDetails[index] && errors.testDetails[index].printSrNo && <span className="text-danger">{errors.testDetails[index].printSrNo.message}</span>}
									</div>

									<div className="col-md-2">
										<label>Report Days</label>
										<input type="number" className="form-control" {...register(`testDetails.${index}.reportDays`)} />
										{errors.testDetails && errors.testDetails[index] && errors.testDetails[index].reportDays && <span className="text-danger">{errors.testDetails[index].reportDays.message}</span>}
									</div>

									<div className="col-md-2">
										<label>Report Time</label>
										<input type="time" className="form-control" {...register(`testDetails.${index}.reportTime`)} />
										{errors.testDetails && errors.testDetails[index] && errors.testDetails[index].reportTime && <span className="text-danger">{errors.testDetails[index].reportTime.message}</span>}
									</div>

									<div className="col-md-2 mt-4">
										<button
											type="button"
											className="btn btn-danger"
											onClick={() => remove(index)}
										>
											Remove
										</button>
									</div>
								</div>
							))}

							<button
								type="button"
								className="btn btn-secondary"
								onClick={() =>
									append({
										type: "Test",
										testId: "",
										shortName: "",
										rate: "",
										doctorId: "",
										rateEditable: false,
										printSrNo: "",
										reportDays: "",
										reportTime: ""
									})
								}
							>
								+ Add Test
							</button>

							<hr />

							{/* BILLING */}
							<div className="col-12">
								<h5 className="mt-3 mb-3 text-primary">
									Billing
								</h5>
							</div>
							<div className="row">
								<div className="col-md-3">
									<label>Gross Amount</label>
									<input type="number" className="form-control" {...register("grossAmount")} />
									{errors.grossAmount && <span className="text-danger">{errors.grossAmount.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Other Charges</label>
									<input type="number" className="form-control" {...register("otherCharges")} />
									{errors.otherCharges && <span className="text-danger">{errors.otherCharges.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Debit Account</label>
									<input type="number" className="form-control" {...register("debitAccount")} />
									{errors.debitAccount && <span className="text-danger">{errors.debitAccount.message}</span>}
								</div>

								<div className="col-md-3">
									<label>Discount %</label>
									<input type="number" className="form-control" {...register("discountPercentage")} />
									{errors.discountPercentage && <span className="text-danger">{errors.discountPercentage.message}</span>}
								</div>

								<div className="col-md-3">
									<label>Discount Amount</label>
									<input type="number" className="form-control" {...register("discountAmount")} />
									{errors.discountAmount && <span className="text-danger">{errors.discountAmount.message}</span>}
								</div>

								<div className="col-md-3">
									<label>Total</label>
									<input type="number" className="form-control" {...register("total")} />
									{errors.total && <span className="text-danger">{errors.total.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Advance</label>
									<input type="number" className="form-control" {...register("advance")} />
									{errors.advance && <span className="text-danger">{errors.advance.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Balance</label>
									<input type="number" className="form-control" {...register("balance")} />
									{errors.balance && <span className="text-danger">{errors.balance.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Payment Mode</label>
									<select className="form-control" {...register("paymentMode")}>
										<option value="">Select</option>
										<option value="cash">Cash</option>
										<option value="online">Online</option>
									</select>
									{errors.paymentMode && <span className="text-danger">{errors.paymentMode.message}</span>}
								</div>
								<div className="col-md-3">
									<label>Remark</label>
									<textarea className="form-control" {...register("remark")} />
									{errors.remark && <span className="text-danger">{errors.remark.message}</span>}
								</div>
							</div>

						</div>

						<div className="card-footer text-end">
							<button className="btn btn-primary" type="submit">
								Submit
							</button>
						</div>
					</form>
				</div>
			</div>
		</Fragment>
	);
};

export default EditLabRegitrationEntry;
